import * as React from "react";
import Component from "../../AbstractComponent";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Button from '@material-ui/core/Button';
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";

export default class AgreementDetailsReadonly extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}

	public getReadonlyReason = (agencyFee: AgencyFeeInterface) => {
		if (agencyFee?.removed) {
			return this.trans("agreement-readonly/removed");
		} else if (!agencyFee?.isConcept) {
			return this.trans("agreement-readonly/signed");
		}
	}
	
  public render() {
		const agencyFee: AgencyFeeInterface = this.props.agencyFee;

		return (
			<div className="contract-details-readonly">
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{display: "flex", alignItems: "baseline"}}>
						<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
							{this.trans("section/agencyfee-title")} 
						</div>
						{
							!this.props.isDefault && agencyFee?.status &&
							<div className="title" style={{color: agencyFee?.getStatusColor()}}>
								{this.trans(agencyFee?.status)}
							</div>
						}
					</div>
					{
						!this.props.isDefault && agencyFee?.firstDate &&
						<div className="date">
							{this.formatter.formatDate(agencyFee?.firstDate)}
						</div>
					}
					{
						!this.props.isDefault && !agencyFee?.firstDate && agencyFee?.date &&
						<div className="date">
							{this.formatter.formatDate(agencyFee?.date)}
						</div>
					}
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "10px"}}>
					<div>
						<div className="counterparty" style={{color: "#757575"}}>
							{agencyFee?.companyName}
						</div>
					</div>

					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
						<div className="amount">{this.formatter.formatNumber(agencyFee?.finalAmount, agencyFee?.currency)}</div>
					</div>
				</div>
					<table>
						<tr>
							<td className="align-left first-column">
								{`${this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}:`}
							</td>
							<td className="align-left">
								{agencyFee?.assignmentServiceStatus && agencyFee?.assignmentServiceStatus !== 1 && this.trans(`assignment_service_status_type_${ AssignmentServiceStatusTypeContainer.pickLabelFromId(agencyFee?.assignmentServiceStatus)?.toLowerCase()}`)}
							</td>
						</tr>
					{
						agencyFee?.percentageFee !== 0 && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("agreement-card/percentagefee-label")}:`}
								</td>
								<td className="align-left">
									{`${this.formatter.simpleFormatNumber(agencyFee?.percentageFee, false)}%`}
								</td>
							</tr>
						)
					}

					{
						agencyFee?.lastDate && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label/end-date")}:`}
								</td>
								<td className="align-left">
									{this.formatter.formatDate(agencyFee?.lastDate)}
								</td>
							</tr>
						)
					}

					{
						agencyFee?.chargeTypes?.length > 0 && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("dialog/agencyfee-field/chargetypes-label")}:`}
								</td>
								<td className="align-left">
									{agencyFee?.chargeTypes?.map(type => this.formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(type?.id), {}, "", false), TypeContainer.pickLabelFromId(type?.id), type?.system)).join(", ")}
								</td>
							</tr>
						)
					}

					{
						agencyFee?.fixedPlusPercentageMode?.id && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}:`}
								</td>
								<td className="align-left">
									{this.formatter.checkTranslationType(this.trans(this.props.globalTypes?.FixedPlusPercentageModes?.[agencyFee?.fixedPlusPercentageMode?.id]?.label), this.props.globalTypes?.FixedPlusPercentageModes?.[agencyFee?.fixedPlusPercentageMode?.id]?.label)}
								</td>
							</tr>
						)
					}
				</table>
				{
					agencyFee?.isReadonly && this.props.mainCardPresentation &&
						<div className="readonly-reason" style={{flexDirection: "column"}}>
							<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
								<div
									className="list-label readonly"
									style={{
										marginRight: "5px",
										maxWidth: "max-content"
									}}
								>
									{agencyFee?.isReadonly && this.trans("label-readonly")}
								</div>
								<div>{this.getReadonlyReason(agencyFee)}</div>
							</div>
						</div>
				}
				{
					!this.props.mainCardPresentation && (
						<div style={{marginTop: "10px", display: "flex", justifyContent: "space-between"}}>
							<Button 
								variant="outlined"
								color="primary"
								onClick={() => {
									if (this.props.updateAgencyFee) {
										this.props.updateAgencyFee.call(this, agencyFee)
									}
								}}
							>
								{this.trans("button-open")}
							</Button>
							<Button 
								variant="outlined"
								style={{color: "#F44336", borderColor: "#F44336"}}
								onClick={() => {
									if (this.props.removeAgencyFee) {
										this.props.removeAgencyFee.call(this, agencyFee)
									}
								}}
							>
								{this.trans("button-remove")}
							</Button>
						</div>
					)
				}
			</div>
		);
  }
}
